// extracted by mini-css-extract-plugin
export var itemSolution = "itemSolution-module--itemSolution--1h6Ak";
export var jsAnimInit = "itemSolution-module--jsAnimInit--TFkex";
export var itemSolution_inner = "itemSolution-module--itemSolution_inner--3jFxs";
export var iconWrap = "itemSolution-module--iconWrap--1Mu1C";
export var textWrap = "itemSolution-module--textWrap--sVnTf";
export var title = "itemSolution-module--title--3-J3i";
export var text = "itemSolution-module--text--2UPWJ";